/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Canonical admission-status code; legality enforced by backend state machines.
 * @export
 */
export const AdmissionStatusCode = {
    Booked: 'booked',
    MovedIn: 'moved_in',
    MovedOut: 'moved_out',
    Lost: 'lost',
    Hospitalized: 'hospitalized',
    Loa: 'loa',
    None: 'none',
    IntakeInProgress: 'intake_in_progress',
    Scheduled: 'scheduled',
    Admitted: 'admitted',
    Transferred: 'transferred',
    Discharged: 'discharged',
    NoAdmit: 'no_admit'
} as const;
export type AdmissionStatusCode = typeof AdmissionStatusCode[keyof typeof AdmissionStatusCode];


export function AdmissionStatusCodeFromJSON(json: any): AdmissionStatusCode {
    return AdmissionStatusCodeFromJSONTyped(json, false);
}

export function AdmissionStatusCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionStatusCode {
    return json as AdmissionStatusCode;
}

export function AdmissionStatusCodeToJSON(value?: AdmissionStatusCode | null): any {
    return value as any;
}

